import { Observable } from 'rxjs';
import { Component, OnInit } from "@angular/core";
import { ConfigService } from "../../shared/services/config.service";

@Component({
  selector: "offers-app-gallery-page",
  templateUrl: "./offers-page.component.html"
})
export class OffersPageComponent implements OnInit {
  images$: Observable<any> = new Observable();

  // images: {
  //   id: number;
  //   name: string;
  // }[];

  constructor(private config: ConfigService) {}

  ngOnInit() {
    this.getBlockData("offers");
  }

  getBlockData(database: string) {
    this.images$ = this.config.getSettings(database);
  }
}
